import { Select } from '@monavate/ui-core';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Select as AntSelect } from 'antd';

const Option = AntSelect.Option;

const OrderName = styled.div`
    font-size: 13px;
    font-weight: 500;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const OrderOption = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
`;

const SelectContainer = styled.div`
    .ant-select-selection-item {
        ${OrderOption} {
            display: flex;
            flex-direction: row-reverse;
            justify-content: flex-end;
            gap: 8px;
        }
        ${OrderName} {
            max-width: 100%;
        }
    }
`;

interface OrderSelectorProps {
    options?: any[];
    defaultValue?: any;
    onChangeCallback: any;
}

const OrderSelector: React.FC<OrderSelectorProps> = ({
    options,
    defaultValue,
    onChangeCallback,
}) => {
    const [ordersSearchQuery, setOrdersSearchQuery] = useState<string>('');
    const [availableOrders, setAvailableOrders] = useState<any[]>(options || []);
    const [value, setValue] = useState<any>();
    useEffect(() => {
        setValue(defaultValue || null);
    }, [defaultValue]);
    const onChange = (reference: string) => {
        setValue(reference);
        onChangeCallback(reference);
    };

    return (
        <SelectContainer>
            <Select
                id="orders-list"
                value={value}
                placeholder="Select"
                popupClassName="single-scroll-popup"
                showSearch
                // @ts-ignore
                onChange={(reference: string) => {
                    onChange(reference);
                }}
                optionFilterProp={'label'}
                onSearch={(value: string) => {
                    setOrdersSearchQuery(value);
                }}
                onSelect={() => {
                    setOrdersSearchQuery('');
                }}
            >
                {availableOrders.map((order: any, index: number) => {
                    return (
                        <Option key={index} value={order.reference} label={order.reference}>
                            <OrderOption>
                                <OrderName>{order.reference}</OrderName>
                            </OrderOption>
                        </Option>
                    );
                })}
            </Select>
        </SelectContainer>
    );
};

export default OrderSelector;
